export enum EnumAmbiente
{
    Producao = 'Produção',
    Teste = 'Teste',
    Homologacao = 'Homologação',
    Desenvolvimento = 'Desenvolvimento'
}
